/*
 *
 * TransactionReversePopup
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 09-Jun-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { nullSafe } from 'Utility/globalMethods'
import TransactionReversePopup from './TransactionReversePopup'
import * as HomepageActions from '../../routes/Homepage/modules/HomepageActions'
import { doHidePopup } from 'Store/actions/popup'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(HomepageActions, dispatch),
  ...bindActionCreators({ doHidePopup }, dispatch)
})

const mapStateToProps = (state) => ({
  isLoading: nullSafe(() => state.loading.localLoading.check_transactions_tab, false)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(TransactionReversePopup)
